import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

// Wait for DOM to be ready
document.addEventListener("DOMContentLoaded", function () {
  // Mobile Menu animation
  const mobileMenuItems = gsap.utils.toArray(".mobile-menu li");
  if (mobileMenuItems.length > 0) {
    gsap.from(mobileMenuItems, {
      duration: 0.5,
      opacity: 0,
      y: -20,
      stagger: 0.1,
      delay: 0.5,
    });
  }

  // Content blocks animation with improved performance
  const contentBlocks = gsap.utils.toArray(
    ".content-blocks-container .content-block"
  );

  if (contentBlocks.length > 0) {
    contentBlocks.forEach((block, index) => {
      gsap.fromTo(
        block,
        {
          opacity: 0,
          y: 50,
        },
        {
          scrollTrigger: {
            trigger: block,
            start: "top 80%",
            toggleActions: "play none none none",
            once: true, // Only play animation once for better performance
          },
          opacity: 1,
          y: 0,
          duration: 1,
          delay: index * 0.1, // Reduced delay for smoother experience
          ease: "power2.out", // Smoother easing
        }
      );
    });
  }
});

// Export for potential external use
export { gsap, ScrollTrigger };
